import React from "react";
import axios from "axios";
import { withStyles } from "tss-react/mui";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Close, ExpandLess, RestaurantMenu } from "@mui/icons-material";
import {
  Checkbox,
  Collapse,
  FormControl,
  FormLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
} from "@mui/material";
import SaveButton from "../../../components/CustomInput/SaveButton";
import { convertObjectToSelectOptions } from "../../../templateHelpers";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Copy extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      saving: false,
      vestigingen: [],
      selectedVestigingen: [],
      selectedVestigingIds: [],
      menukaartenProductNesting: [],
      collapsibleProductsOpen: [],
      showProductSelection: false,
      producten: [],
      selectedProductIds: [],
      updateExistingProducts: 1,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && this.state.vestigingen.length === 0) {
      this.loadVestigingen();
    }

    // kan dit werken als je de hele comparison met menukaartIds weghaalt en alleen
    if (this.props.open && this.props.open !== prevProps.open) {
      let query = [
        {
          field: "id",
          operator: "in",
          value: this.props.menukaartIds,
        },
      ];

      axios
        .post(
          "core/kaarten/search?per_page=1000&fields=id,naam,producten.naam,producten.id&sort_field=naam&sort_dir=asc",
          query
        )
        .then((response) => {
          const query_res = response.data.data.data;
          const producten = query_res.flatMap((menukaart) => menukaart.producten);
          this.setState({ producten: producten });
          this.setState({ menukaartenProductNesting: query_res });
          // this opens all collapsible list headings by default
          this.setState({ collapsibleProductsOpen: query_res.map(() => true) });
          this.fillSelectedIds();
        });
    }

    /**
     * Als showProductSelection veranderd naar false dan alle producten selecteren mocht dat nog niet zijn.
     */
    if (
      this.state.showProductSelection === false &&
      this.state.selectedProductIds.length !== this.state.producten.length
    ) {
      this.fillSelectedIds();
    }
  }

  loadVestigingen = () => {
    axios
      .get(
        "core/vestigingen?per_page=5000&fields=id as value, systeemNaam as label&sort_field=systeemNaam&sort_dir=asc"
      )
      .then((response) => {
        let vestigingen = response.data.data.data;
        this.setState({ vestigingen: vestigingen });
      });
  };

  fillSelectedIds = () => {
    let productIds = this.state.producten.map((prop, key) => {
      return prop.id;
    });

    this.setState({ selectedProductIds: productIds });
  };

  handleType = (name) => (event) => {
    let newState = { ...this.state };
    newState[name] = event.target.value;
    this.setState(newState);
  };

  handleProductSelectionCheckbox = (event) => {
    let newState = { ...this.state };
    newState.showProductSelection = event.target.checked;
    this.setState(newState);
  };

  setSelectedIds = (id, event) => {
    let newSelectedIds = [...this.state.selectedProductIds];

    if (event.target.checked) {
      newSelectedIds.push(id);
    } else {
      let indexKey = newSelectedIds.indexOf(id);
      newSelectedIds.splice(indexKey, 1);
    }

    this.setState({ selectedProductIds: newSelectedIds });
  };

  isSelectedProduct = (id) => {
    return this.state.selectedProductIds.indexOf(id) !== -1;
  };

  isAllSelected = () => {
    return this.state.selectedProductIds.length === this.state.producten.length;
  };

  toggleAllSelected = () => {
    if (this.isAllSelected()) {
      this.setState({ selectedProductIds: [] });
    } else {
      this.fillSelectedIds();
    }
  };

  renderButtonText = () => {
    if (this.state.showProductSelection === false || this.isAllSelected() === true) {
      if (this.props.menukaartIds.length > 1) {
        return getTranslation(
          "menukaarten.modal.copy.button.text.pluralmenu",
          "Kopieer geselecteerde menukaarten met alle producten"
        );
      }
      return getTranslation("menukaarten.modal.copy.button.text", "Kopieer menukaart met alle producten");
    } else {
      if (this.props.menukaartIds.length > 1) {
        return getTranslation(
          "menukaarten.modal.copy.button.menuplural",
          "Kopieer geselecteerde menukaarten met de geselecteerde product(en)"
        );
      }
      return getTranslation(
        "menukaarten.modal.copy.button.text2",
        "Kopieer menukaart met de geselecteerde product(en)"
      );
    }
  };

  save = () => {
    const form = this.formRef.current;
    if (form.checkValidity()) {
      this.setState({ saving: true });
      let data = {
        menukaart_ids: this.props.menukaartIds,
        vestiging_ids: this.state.selectedVestigingIds,
        product_ids: this.state.selectedProductIds,
        updateExistingProducts: this.state.updateExistingProducts,
      };

      axios.post("core/kaarten/dupliceren", data).then((_) => {
        this.setState({ saving: false });
        this.props.refreshTable();
        this.props.toggle();
      });
    } else {
      form.reportValidity();
    }
  };

  render() {
    // performance: the entire modal gets rendered even if this.props.open===false
    // might want to short that
    const { classes } = this.props;

    let vestigingenItems = convertObjectToSelectOptions(this.state.vestigingen, classes);
    let handleClick = (e) => {
      const current = [...this.state.collapsibleProductsOpen];
      // invert value
      const collapse_id = e.currentTarget.getAttribute("data-collapse-id");
      current[collapse_id] = !current[collapse_id];
      this.setState({ collapsibleProductsOpen: current });
    };

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            {this.props.menukaartIds.length > 1 ? (
              <TranslationWrapper
                tDefault={"Kopieer geselecteerde menukaarten"}
                tKey={"menukaarten.modal.copy.titel.plural"}
              />
            ) : (
              <TranslationWrapper tDefault={"kopieer een menukaart"} tKey={"menukaarten.modal.copy.titel"} />
            )}
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            ref={this.formRef}
          >
            <FormControl className={classes.selectFormControl} fullWidth required>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper tDefault={"Vestiging"} tKey={"menukaarten.modal.copy.form.selectedVestiging"} />
              </FormLabel>
              <AsynchronousAutocomplete
                async={{
                  url: "core/vestigingen/search?fields=id as value, systeemNaam as label",
                  searchField: "systeemNaam",
                  perPage: 150,
                }}
                defaultValue={this.state.selectedVestigingen}
                multiple
                onChange={(e, options) => {
                  this.setState({
                    selectedVestigingen: options,
                    selectedVestigingIds: options.map((option) => option.value),
                  });
                }}
                showTagsInInput={false}
              />
            </FormControl>
            <FormLabel className={classes.labelHorizontal} style={{ alignSelf: "center" }}>
              <TranslationWrapper tDefault={"Product Selectie"} tKey={"menukaarten.modal.copy.form.productSelectie"} />
            </FormLabel>
            <Checkbox onChange={this.handleProductSelectionCheckbox} />
            {this.state.showProductSelection ? (
              <div>
                <FormLabel className={classes.labelHorizontal}>
                  <Checkbox checked={this.isAllSelected()} onChange={this.toggleAllSelected} />
                  <b>Alle producten</b>
                </FormLabel>
                <List>{this.renderProductSelection(handleClick, classes)}</List>
              </div>
            ) : null}
          </form>
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <Paper sx={{ p: 1 }}>
            <Stack direction={"column"} gap={1}>
              <Select
                onChange={(e) => {
                  this.setState({ updateExistingProducts: e.target.value });
                }}
                value={this.state.updateExistingProducts}
              >
                <MenuItem value={1}>
                  <TranslationWrapper tKey={"Only create new product if Api ID doesn't exist"} />
                </MenuItem>
                <MenuItem value={0}>
                  <TranslationWrapper tKey={"Create always a new product (also if Api ID already exists)"} />
                </MenuItem>
              </Select>
              <SaveButton buttonText={this.renderButtonText()} onClick={this.save} saving={this.state.saving} />
            </Stack>
          </Paper>
        </DialogActions>
      </Dialog>
    );
  }

  renderProductSelection(handleClick, classes) {
    const renderProductCheckbox = (menukaart) =>
      menukaart.producten.map((product, product_idx) => {
        return (
          <ListItem key={product_idx}>
            <FormLabel className={classes.labelHorizontal}>
              <Checkbox
                checked={this.isSelectedProduct(product.id)}
                onChange={(e) => this.setSelectedIds(product.id, e)}
              />
              {product.naam}
            </FormLabel>
          </ListItem>
        );
      });

    return this.state.menukaartenProductNesting.map((menukaart, idx) => {
      return (
        <div>
          <ListItem button data-collapse-id={idx} key={idx} onClick={handleClick}>
            <ListItemIcon>
              <RestaurantMenu />
            </ListItemIcon>
            <ListItemText>{menukaart.naam}</ListItemText>
            {this.state.collapsibleProductsOpen[idx] ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.collapsibleProductsOpen[idx]}>
            <List>{renderProductCheckbox(menukaart)}</List>
          </Collapse>
        </div>
      );
    });
  }
}

export default withStyles(Copy, notificationsStyle);
